module.exports = __webpack_public_path__ + "static/media/4.8b6eb297.jpg";